<template>
    <section class="help-detail-panel">
        <pub-header :headTitle="'问题详情'" :isCustomMethod="true" @customMethod="closeHelpDetail"></pub-header>
        <div class="detail-cont-panel">
            <div class="title">
                <img class="icon" src="../../assets/images/i_question.png">
                <p>{{helpDetail.title}}</p>
            </div>
            <div class="cont" v-html="helpDetail.content"></div>
        </div>
        <div class="detail-foot-panel">没有搜到？可<a class="stress" href="tel:4001815118">联系客服</a>（工作日 09:00 - 21:00）</div>
    </section>
</template>
<script>
export default {
    props: {
        helpDetail: {
            type: Object
        },
    },
    methods: {
        closeHelpDetail(){
            this.$emit("closeHelpDetail");
        }
    },
}
</script>
<style>
/* 详情 */
.help-detail-panel{
    width: 100%;
    background-color: #efefed;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2000;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.detail-cont-panel{
    flex: 1 1 auto;
    width: 100%;
    padding: 0.5rem 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #ffffff;
}
.detail-cont-panel .title{
    width: 90%;
    height: 0.5rem;
    padding: 0 1% 0.2rem;
    margin: 0 auto;
    border-bottom: 1px solid #c9c9ca;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.detail-cont-panel .title .icon{
    flex: 0 0 auto;
    width: 0.46rem;
    position: relative;
    margin-top: 0.08rem;
    margin-right: 0.2rem;
}
.detail-cont-panel .title p{
    flex: 1 1 auto;
    font-size: 0.3rem;
    color: #3f3a39;
    font-weight: bold;
}
.detail-cont-panel .cont{
    width: 90%;
    margin: 0.12rem auto 0;
    text-align: left;
    font-size: 0.26rem;
    color: #3f3a39;
    line-height: 0.4rem;
}
.detail-cont-panel .cont .item{
    width: 100%;
    padding: 0.2rem 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
}
.detail-cont-panel .cont .bullet{
    flex: 0 0 auto;
}
.detail-cont-panel .cont p{
    flex: 1 1 auto;
}
.detail-foot-panel{
    flex: 0 0 auto;
    width: 92%;
    height: 3rem;
    padding: 0.3rem 4%;
    text-align: left;
    font-size: 0.28rem;
    color: #595656;
    line-height: 0.4rem;
    font-weight: bold;
}
.detail-foot-panel .stress{
    color: #ea531a;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/service/help-detail.vue